import React, {useState} from 'react'
import {Link, useLocation, useHistory} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import Button from 'components/buttons/';
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import UI from "../../../components/UI";
import UIUtil from "utils/UIUtils";
import CookieUtil from "../../../utils/CookieUtil";
import userStore from "common/user/store/UserStore";
import mainPopupStore from "common/popup/store/MainPopupStore";
import {observer} from 'mobx-react-lite'
import classNames from "classnames";
import AuthMenuLink from "components/link";
import TbSysPop from 'domain/main/sys/pop/TbSysPop';
import Slider from "react-slick"; //추가
import "slick-carousel/slick/slick.css"; //추가
import "slick-carousel/slick/slick-theme.css";
import menuStore from "../../../common/menu/store/MenuStore";
import UIUtils from "../../../utils/UIUtils"; //추가

// [M.20240716] 추가
export function RelationCompany() {
    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true
    };
    const bnr = [
        {src:'win-win.png',alt:'대중소기업농어업협력재단',url:'https://www.win-win.or.kr'},
        {src:'winwingrowth.png',alt:'동반성장위원회',url:'https://www.winwingrowth.or.kr'},
        {src:'index.win-win.png',alt:'동반성장지수',url:'http://index.win-win.or.kr'},
        {src:'winwinnuri.png',alt:'상생누리',url:'https://www.winwinnuri.or.kr'},
        {src:'kescrow.png',alt:'기술자료임치센터',url:'https://www.kescrow.or.kr'},
        {src:'winwinfund.png',alt:'농어촌상생기금',url:'https://www.winwinfund.or.kr'},
        {src:'benis.png',alt:'성과공유확산',url:'https://www.benis.or.kr'},
    ];
    return (
        <>
            <Slider {...settings}>
                {bnr.map((bnr, index) =>
                    <a key={index} href={bnr.url} target="_blank" rel="noreferrer"><img src={require('assets/img/pages/'+bnr.src+'')} alt={bnr.alt} /></a>
                )}
            </Slider>
        </>
    );
}
// [M.20240716] 추가

function HomeContainer() {
    const location = useLocation();
    const receivedData = (location.state as any)?.data;
    const history = useHistory();
    const [boardList, setBoardList] = useState<any[]>([]);
    const [popList, setPopList] = useState<any[]>([]);
    const [totalCnt, setTotalCnt] = useState(0);
    const notiTpCd = 'N';
    const [popupList, setPopupList] = React.useState<React.JSX.Element[]>();
    const [sidebar, setSidebar] = useState(false);
    const [demandList, setDemandList] = useState<any[]>([]);

    // 페이징 설정
    const [pageNum, setPageNum] = useState(1);      // 페이지 번호
    const [pageSize, setPageSize] = useState(4);    // 화면에 출력할 목록 갯수(10개)

    //초기 데이터 설정
    let data = {};
    let param = {};

    async function getRead() {

        param = {
            "NOTI_TP_CD": notiTpCd,
            "PAGE_NUM": pageNum,
            "PAGE_SIZE": pageSize
        };

        const response: any = await CommonUtil.execute({
            url: 'usr_main',
            data: param
        })
            .then((response: any) => {
                data = response.REC;
                // 안내사항 리스트
                setBoardList(response.REC);
                // 안내사항 전체ROW개수
                setTotalCnt(response.TOTAL);

                setDemandList(response.REC2);

                // 팝업 리스트
//             setPopList(response.REC);
//             console.log(response.REC);

            }).catch((error) => {
                CommonUtil.showAxiosError(error);
                return;
            });
    }

    // 페이지 이동
    const pageMove = (pageId) => {
        // 기금소개 화면으로 이동
        if (pageId == '1900') {
            history.push({pathname: '/main/usr_1900/usr_1900'});
        } else if (pageId == 'noti') {
            history.push({pathname: '/main/usr_2300/usr_2300'});
        } else if( pageId == 'demand') {
            history.push({pathname: '/main/usr_1900/usr_1904'});
        }
    }

    async function clickPage(notiNo) {
        let dataToSend = {NOTI_NO: notiNo};
        // 다른 페이지로 이동하면서 데이터 전달
        history.push({
            pathname: '/main/usr_2300/usr_2301',
            state: {data: dataToSend}
        });
    }

    async function clickDemandPage(demandNo) {
        let dataToSend = {DEMAND_NO: demandNo};

        if(userStore.authenticated){
            // 다른 페이지로 이동하면서 데이터 전달
            history.push({
                pathname: '/main/usr_1900/usr_1908',
                state: {data: dataToSend}
            });
        } else {
            UIUtils.alert("로그인이 필요합니다.").then(() =>
                history.push({
                    pathname: '/main/usr_1000/usr_1300',
                    search: 'url=/main/usr_1900/usr_1908',
                    state: {data: dataToSend}
                })
            );
        }

    }

    React.useEffect(() => {
        if (!mainPopupStore.isLoaded) {
            mainPopupStore.readPopups();
        } else {
            (async () => {
                Promise.all(
                    mainPopupStore.popups
                        .filter(tbSysPop => CookieUtil.get(tbSysPop.getPopNo()) == null || CookieUtil.get(tbSysPop.getPopNo()) === false)
                        .map(tbSysPop => UIUtil.getFile(tbSysPop.getFile().tbComFileMapngDetailList[0])
                            .then(fileBlob => fileBlob ? UIUtil.blobToUrl(fileBlob) : "")
                            .then(fileUrl => {
                                return (
                                    <MainPopupContainer tbSysPop={tbSysPop} imgUrl={fileUrl} key={tbSysPop.getPopNo()}/>
                                )
                            })
                        )
                ).then(values => {
                    setPopupList(values);
                })
            })()
        }
    }, [mainPopupStore.isLoaded])


    React.useEffect(() => {
        menuStore.removeCurrentMenu();
        getRead();

    }, [])//effect

    return (
        <PageContainer session={false}>
            <div className='fww-con'>
                <main className="usr-home">
                    <section className="home-section" data-section="visual">
                        <div className="inner">
                            <div className="visual-box">
                                <p className="sub-tx">대·중소기업상생협력기금</p>
                                <h1>상생협력</h1>
                                <h3>지속 가능한 발전, 상생협력 촉진, 동반성장</h3>
                                <div className="tx-cont">
                                    대·중소기업·농어업 협력재단에 출연하는 민간 기금으로 대·중소기업 간의 지속가능한 발전,<br/>
                                    상생협력 촉진 및 동반성장을 통한 국민경제의 지속성장 기반 마련에 이바지합니다.
                                </div>
                                <Button color='pri' size="big" onClick={() => pageMove('1900')}>기금소개 바로가기</Button>
                            </div>
                        </div>
                    </section>
                    {/*
                    <section className="home-section" data-section="business">
                        <div className="inner">
                            <h2 className="section-title">대·중소기업상생협력기금 활용 사업</h2>
                            <ul className="business-group">
                                <li><a href="https://win-win.or.kr/kr/contents/busi_win_2/view.do" target="_blank"><i className="ico bs01"></i>동반성장투자재원</a></li>
                                <li><a href="https://win-win.or.kr/kr/contents/busi_skill_6/view.do" target="_blank"><i className="ico bs02"></i>공동투자형기술개발</a></li>
                                <li><a href="https://win-win.or.kr/kr/contents/busi_skill_4/view.do" target="_blank"><i className="ico bs03"></i>산업혁신운동</a></li>
                                <li><a href="https://win-win.or.kr/kr/contents/busi_skill_8/view.do" target="_blank"><i className="ico bs04"></i>대·중소 상생형스마트공장</a></li>
                                <li><a href="https://win-win.or.kr/kr/contents/busi_skill_5/view.do" target="_blank"><i className="ico bs05"></i>대·중소기업 혁신파트너</a></li>
                                <li><a href="https://win-win.or.kr/kr/contents/busi_coex_5/view.do" target="_blank"><i className="ico bs06"></i>대중소기업 동반진출</a></li>
                                <li><a href="https://win-win.or.kr/kr/contents/busi_win_3/view.do" target="_blank"><i className="ico bs07"></i>기업자율형 상생프로그램</a></li>
                                <li><a href="https://win-win.or.kr/kr/contents/busi_coex_1/view.do" target="_blank"><i className="ico bs08"></i>성과 공유제</a></li>
                                <li><a href="https://win-win.or.kr/kr/contents/busi_coex_2/view.do" target="_blank"><i className="ico bs09"></i>협력이익 공유제</a></li>
                                <li><a href="http://winwingrowth.or.kr/03_business_01_04_01.do" target="_blank"><i className="ico bs10"></i>협력사ESG 평가지원</a></li>
                            </ul>
                        </div>
                    </section>
                    */}
                    <section className="home-section" data-section="board">
                        <div className="inner">
                            <div className="board-group">
                                <div className="bd-card notice">
                                    <h3 className="bd-title">안내사항</h3>
                                    <ul className="bd-list">
                                        {boardList != null ? (
                                            boardList.map((board, index) => (
                                                <li key={board.NOTI_NO}>
                                                    {board.NOTI_DIV_CD == '1' &&
                                                        <label className="badge badge-22 blue">공통공지</label>
                                                    }
                                                    {board.NOTI_DIV_CD == '2' &&
                                                        <label className="badge badge-22 red">주요자료</label>
                                                    }
                                                    {board.NOTI_DIV_CD == '3' &&
                                                        <label className="badge badge-22 green">사업공지</label>
                                                    }
                                                    <div className="subject">
                                                        <a href="#" onClick={(e) => {
                                                            e.preventDefault();
                                                            clickPage(board.NOTI_NO);
                                                        }} className="tx tx-bd2 tx-link">{board.NOTI_TITLE}</a>
                                                    </div>
                                                    <div
                                                        className="date">{DateUtil.toDateFormat(board.REG_DATE, "YYYY-MM-DD")}</div>
                                                </li>
                                            ))
                                        ) : (
                                            <li key={'board-none'}>게시물이 없습니다.</li>
                                        )}
                                    </ul>
                                    <button type="button" className="button-more" onClick={() => pageMove('noti')}>더보기</button>
                                </div>
                                <div className="bd-card research">
                                    <h3 className="bd-title">수요조사</h3>
                                    <ul className="bd-list">
                                        {demandList != null ? (
                                            demandList.map((demand, index) => (
                                                <li key={demand.DEMAND_NO}>
                                                    {demand.STS_CD == 'Y' &&
                                                        <label className="badge badge-22 green">모집중</label>
                                                    }
                                                    {demand.STS_CD == 'N' &&
                                                        <label className="badge badge-22 gray">모집완료</label>
                                                    }
                                                    <div className="subject">
                                                        <a href="#" onClick={(e) => {
                                                            e.preventDefault();
                                                            clickDemandPage(demand.DEMAND_NO);
                                                        }} className="tx tx-bd2 tx-link">{demand.TITLE}</a>
                                                    </div>
                                                    <div className="date">{demand.REG_DATE}</div>
                                                </li>
                                            ))
                                        ) : (
                                            <li key={'board-none'}>게시물이 없습니다.</li>
                                        )}
                                    </ul>
                                    <button type="button" className="button-more" onClick={() => pageMove('demand')}>더보기</button>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="home-section" data-section="banner">
                        <div className="inner">
{/*
                            <div className="banner-group">
                                <a href="https://www.winwinnuri.or.kr/cm/mainView.do" target="_blank"><img src={require('assets/img/pages/usr_bnr01.png')} alt="상생누리"/></a>
                                <a href="https://www.winwinpay.or.kr/index.do#PAGE=1" target="_blank"><img src={require('assets/img/pages/usr_bnr02.png')} alt="상생결제 제도"/></a>
                                <a href="https://www.kescrow.or.kr/tems/main/page.do" target="_blank"><img src={require('assets/img/pages/usr_bnr03.png')} alt="대중소 기업 농어업 협력재단 기술자료 임치센터"/></a>
                                <a href="https://proof.kescrow.or.kr/verification/" target="_blank"><img src={require('assets/img/pages/usr_bnr04.png')} alt="대중소 기업 농어업 협력재단 원본 증명서비스"/></a>
                                <a href="https://www.winwinfund.or.kr/main.do" target="_blank"><img src={require('assets/img/pages/usr_bnr05.png')} alt="농어촌 상생협력기금"/></a>
                                <a href="https://www.winplus.or.kr/index.do" target="_blank"><img src={require('assets/img/pages/usr_bnr06.png')} alt="협력이익공유제 종합정보시스템"/></a>
                            </div>
*/}
                            <div className="banner-group">
                                <RelationCompany/>
                            </div>
                        </div>
                    </section>
                    <div className={sidebar ? 'home-sidebar' : 'home-sidebar closed'}>
                        <div className="sidebar-list">
                            <div className="direct-items">
                                <h3>출연관리</h3>
                                <ul>
                                    <li><AuthMenuLink menuId={"SEL1QF5E4F802B1130"} className="item-link"><i
                                        className="ico don1"></i>출연신청</AuthMenuLink></li>
                                    <li><AuthMenuLink menuId={"SEL1QZB094E66153D0"} className="item-link"><i
                                        className="ico don2"></i>출연현황</AuthMenuLink></li>
                                </ul>
                            </div>
                            <div className="direct-items">
                                <h3>과제관리</h3>
                                <ul>
                                    <li><AuthMenuLink menuId={"SEL1VJ96B20DF073F0"} className="item-link"><i
                                        className="ico don1"></i>과제승인신청</AuthMenuLink></li>
                                    <li><AuthMenuLink menuId={"SEL1W3066F33041890"} className="item-link"><i
                                        className="ico don2"></i>과제현황</AuthMenuLink></li>
                                </ul>
                            </div>
                            <div className="direct-items">
                                <h3>지급관리</h3>
                                <ul>
                                    <li><AuthMenuLink menuId={"SEL1X1CA2EAF3C1350"} className="item-link"><i
                                        className="ico don1"></i>지급정산신청</AuthMenuLink></li>
                                    <li><AuthMenuLink menuId={"SEL1XH60FF14D5FBB0"} className="item-link"><i
                                        className="ico don2"></i>지급현황</AuthMenuLink></li>
                                </ul>
                            </div>
                            <button type="button" className="sidebar-closed" onClick={() => setSidebar(false)}>바로가기 닫기
                            </button>
                        </div>
                        <button type="button" className="sidebar-open" onClick={() => setSidebar(true)}><span>업무별<br/>바로가기</span>
                        </button>
                    </div>
                </main>
            </div>
            {/* 팝업 영역 */}
            {popupList}
        </PageContainer>
    );
}

export default observer(HomeContainer);

const MainPopupContainer = observer(({tbSysPop, imgUrl}: { tbSysPop: TbSysPop, imgUrl: string }) => {
    const [isShow, setShow] = React.useState(true);
    return (
        <div className={classNames("main-img-popup", {hide: !isShow})}
             style={{
                 width: tbSysPop.getPopWidth(),
                 height: tbSysPop.getPopHeight(),
                 position: "absolute",
                 left: tbSysPop.getPopLeftPos(),
                 top: tbSysPop.getPopTopPos(),
                 background: tbSysPop.getImgPath(),
                 zIndex: 999,
             }}
        >
            {tbSysPop.getLinkUrl() != '' ?
                (
                    <a href={tbSysPop.getLinkUrl()} target="_blnak">
                        <img
                            src={imgUrl}
                            alt={""}
                            width={tbSysPop.getPopWidth()}
                            height={tbSysPop.getPopHeight()}
                        />
                    </a>
                ) : (
                    <a href="#" onClick={e => e.preventDefault}>
                        <img
                            src={imgUrl}
                            alt={""}
                            width={tbSysPop.getPopWidth()}
                            height={tbSysPop.getPopHeight()}
                        />
                    </a>
                )}
            <div className="bottom-area"
                 style={{
                     background: "#444",
                     height: 34,
                     position: "relative",
                     width: tbSysPop.getPopWidth(),
                 }}
            >
                <button className="btn-close-today" type="button" onClick={() => {
                    CookieUtil.set(tbSysPop.getPopNo(), true, {expires: CookieUtil.getExpiresDate(1)});
                    setShow(false);
                }}>오늘하루열지않기
                </button>
                <button className="btn-close" type="button" onClick={(event) => {
                    setShow(false);
                }}>닫기
                </button>
            </div>
        </div>
    )
})